var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F9A01B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99254 7.71473C5.21045 5.68093 6.95749 4.13867 9.00292 4.13867C11.0484 4.13867 12.7955 5.68093 13.0134 7.71474L13.3847 10.1338C13.509 10.9434 12.8825 11.6734 12.0634 11.6734H5.94256C5.12344 11.6734 4.49695 10.9434 4.62123 10.1338L4.99254 7.71473ZM10.7191 7.67772C10.8615 7.53534 10.8615 7.3045 10.7191 7.16212C10.5768 7.01975 10.3459 7.01975 10.2036 7.16212L8.51691 8.84875L7.80248 8.13436C7.6601 7.99197 7.42926 7.99197 7.28688 8.13436C7.14451 8.27674 7.14451 8.50755 7.28688 8.64993L8.25912 9.62215C8.4015 9.76453 8.63231 9.76453 8.77469 9.62215L10.7191 7.67772Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00173 13.8607C8.00507 13.8607 7.1485 13.2608 6.77344 12.4023H11.2301C10.855 13.2608 9.99845 13.8607 9.00173 13.8607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBell);
export default __webpack_public_path__ + "static/media/card-bell.e34e9b61b38d18b5d2bccf243a40ec21.svg";
export { ForwardRef as ReactComponent };